import ApiUser from '../../api/api-user';
import { UserDTO } from '../../api/model';
import { actionTypes as at } from './constants';
import { CognitoAuthResultType } from '../../lib/cognito-util';
import UserHelper from '../../lib/user-helper';

export const actionGetMyProfile = () => {
    return async (dispatch, getState) => {
        const result: UserDTO = await ApiUser.getMyUserProfile();
        dispatch(actionGetMyProfileSuccess(result));
    };
};

export const actionGetMyProfileSuccess = (user: UserDTO) => {
    return {
        type: at.GET_MY_PROFILE_SUCCESS,
        payload: user,
    };
};

export const actionReloadProfile = () => {
    return async (dispatch) => {
        await dispatch(actionGetMyProfile());
    };
};

export const actionLoginSuccess = (auth: CognitoAuthResultType) => {
    return async (dispatch) => {
        UserHelper.saveToken(auth);
        dispatch(actionGetMyProfile());
    };
};

export const actionLogoutUser = () => {
    return (dispatch) => {
        UserHelper.resetTokens();
        dispatch({
            type: at.LOGOUT_USER,
        });
    };
};
